import SeriouslyApp from './lib/svelte/main/SeriouslyApp.svelte';
import './styles/webseriously.css';

new SeriouslyApp({ target: document.body });
